import { render, staticRenderFns } from "./SeitenUebersicht.vue?vue&type=template&id=4a56a6fe&scoped=true&"
var script = {}
import style0 from "./SeitenUebersicht.vue?vue&type=style&index=0&id=4a56a6fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a56a6fe",
  null
  
)

export default component.exports